export enum DeliveryNoteType {
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  LOADING_ORDER = 'LOADING_ORDER',
}
